import React from 'react';

const UnauthorizedPage = () => {
  return (
    <div>
      <h2>Unauthorized</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default UnauthorizedPage;
